<template>
  <a-modal v-model="isShow" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{span: 5}" :wrapper-col="{span: 19}">
      <a-form-model-item label="发布平台" prop="line_id">
        <a-select
          v-model="form.line_id"
          allowClear
          show-search
          option-filter-prop="children"
          placeholder="请选择"
          style="width: 100%"
        >
          <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="展示名称" prop="title">
        <a-input v-model.trim="form.title" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="展示位置" prop="show_position">
        <a-select
          v-model="form.show_position"
          mode="multiple"
          allowClear
          show-search
          option-filter-prop="children"
          placeholder="请选择"
          style="width: 100%"
        >
          <a-select-option v-for="item in LINKS_SHOW_POSITION" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="链接地址" prop="url">
        <a-input v-model.trim="form.url" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="打开方式" prop="target">
        <a-select
          v-model="form.target"
          allowClear
          show-search
          option-filter-prop="children"
          placeholder="请选择"
          style="width: 100%"
        >
          <a-select-option v-for="item in LINKS_TARGET" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="终止时间" prop="end_at">
        <v-date-picker v-model="form.end_at" placeholder="请选择" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="描述" prop="description">
        <a-input v-model.trim="form.description" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status" name="radioGroup">
          <a-radio v-for="item in LINKS_STATUS" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取 消
      </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit">
        提 交
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch } from '@vue/composition-api'
import { form, rules } from '../business/linkList'
import dialog from '@/composables/dialog'
import compuedFun from '../computed/'
import api from '@/api/'

const title = {
  Add: '新增链接',
  Edit: '编辑链接'
}

export default defineComponent({
  mixins: [ dialog ],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      form: { ...form }
    })

    watch(() => _this.params, async () => {
      state.form = JSON.parse(JSON.stringify(_this.params))
      state.form.line_id = Number(state.form.line_id)
    })

    watch(() => _this.isEdit, async () => {
      state.title = _this.isEdit ? title.Edit : title.Add
    })

    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          if (valid) {
            if (_this.isEdit) {
              res = await api.updateLink(data)
            } else {
              res = await api.addLink(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods
    }
  }
})
</script>
